import { c as _c } from "react/compiler-runtime";
import { htmlToText } from '../utils/html-to-text';
import WordDiff from './word-diff';
type ProseDiffProps = {
  current: string;
  suggested: string;
};
const ProseDiff = t0 => {
  const $ = _c(7);
  const {
    current,
    suggested
  } = t0;
  let t1;
  if ($[0] !== current) {
    t1 = htmlToText(current);
    $[0] = current;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== suggested) {
    t2 = htmlToText(suggested);
    $[2] = suggested;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <WordDiff current={t1} suggested={t2} className="text-body-3 text-secondary leading-snug" />;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default ProseDiff;